import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText} from "@material-ui/core";
import { useAuthenticatedUser } from '../../../utilities/useAuthenticatedUser';

interface Props {
    openConfirmationDialog: boolean;
    toggleConfirmationDialog: () => void;
}

export function ConfirmationDialog(props:Props) {
    const { openConfirmationDialog, toggleConfirmationDialog } = props;
    const user = useAuthenticatedUser();

    return (
        <Dialog open={openConfirmationDialog} onClose={toggleConfirmationDialog} >
        <DialogTitle>Nicely done, your account has been updated.</DialogTitle>
        <DialogContent>
            <DialogContentText>You'll see your updated pricing on your {new Date(user.makerSubscription?.serviceStartDate!).toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})} billing statement. Thank you and enjoy Sermon Maker</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={toggleConfirmationDialog} color="primary">
                Close
            </Button>
        </DialogActions>
    </Dialog>
    );
}